// RewardsScreen.tsx

import { useState } from "react"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H2 } from "@/components/standard/BFText"
import { PrimaryDarkButton } from "@/components/buttons/CommonButtons"
import { TextTab } from "@/components/tabs/TextTabs"
import { useRewardsProgramData } from "@/queries/user"
import FullScreenLoader from "@/components/loading/FullScreenLoader"
import { RewardsTab } from "@/screens/rewards/RewardsTab"
import { EarningPointsTab } from "@/screens/rewards/EarningPointsTab"
import { useRefer } from "@/screens/rewards/utils"

export default function Rewards() {
  const [tab, setTab] = useState("rewards")
  const onRefer = useRefer("rewards")
  const { data: rewardsProgramData } = useRewardsProgramData()

  if (!rewardsProgramData) {
    return <FullScreenLoader />
  }

  return (
    <BFScreen
      noBackButton={true}
      dark={true}
      headerSticky={false}
      gradientBackground={true}
      header={
        <Vertical className={"px-5 py-2 pb-0"}>
          <Horizontal className={"justify-between"}>
            <Vertical>
              <H2 className={"text-white"}>Backflip Rewards</H2>
            </Vertical>
            <PrimaryDarkButton
              className={"w-[150px]"}
              onPress={onRefer}
              size={"sm"}
              title={"Refer a Friend"}
              testID={"refer-a-friend-button"}
            />
          </Horizontal>
          <Horizontal className={"mt-10"}>
            <TextTab
              dark={true}
              selected={tab === "rewards"}
              label={"Rewards"}
              value={"rewards"}
              onSelect={() => {
                setTab("rewards")
              }}
            />
            <TextTab
              dark={true}
              label={"Earning Points"}
              selected={tab === "points"}
              value={"points"}
              onSelect={() => {
                setTab("points")
              }}
            />
          </Horizontal>
        </Vertical>
      }
    >
      {tab === "rewards" ? (
        <RewardsTab setTab={setTab} />
      ) : (
        <EarningPointsTab />
      )}
    </BFScreen>
  )
}
